import React from 'react';
import './EditorPanel.css';
import MeowInstrument from './MeowInstrument';
import PianoInstrument from './PianoInstrument';
import DrumsInstrument from './DrumsInstrument';
import DurationSelector from './DurationSelector';

function EditorPanel({ currentInstrument, setCurrentInstrument, currentDuration, setCurrentDuration, onAddNote, selectedMeow }) {
  return (
    <div className="editor-panel">
      <h2>🎹 编辑工具区</h2>
      
      <div className="instrument-tabs">
        <button
          className={`tab-btn ${currentInstrument === 'meow' ? 'active' : ''}`}
          onClick={() => setCurrentInstrument('meow')}
        >
          🐱 喵喵琴
        </button>
        <button
          className={`tab-btn ${currentInstrument === 'piano' ? 'active' : ''}`}
          onClick={() => setCurrentInstrument('piano')}
        >
          🎹 钢琴
        </button>
        <button
          className={`tab-btn ${currentInstrument === 'drums' ? 'active' : ''}`}
          onClick={() => setCurrentInstrument('drums')}
        >
          🥁 架子鼓
        </button>
      </div>

      {/* 节拍选择器 */}
      <DurationSelector 
        selectedDuration={currentDuration}
        onDurationChange={setCurrentDuration}
      />

      {/* 休止符按钮 */}
      <div className="rest-control">
        <button 
          className="rest-btn"
          onClick={() => onAddNote('00', '00')}
          title="添加休止符（停顿）"
        >
          <span className="rest-icon">0</span>
          <span className="rest-label">添加休止符</span>
        </button>
        <p className="rest-hint">💡 休止符表示停顿，时值由当前选择的节拍决定</p>
      </div>

      <div className="instrument-content">
        {currentInstrument === 'meow' && <MeowInstrument onAddNote={onAddNote} selectedMeow={selectedMeow} />}
        {currentInstrument === 'piano' && <PianoInstrument onAddNote={onAddNote} />}
        {currentInstrument === 'drums' && <DrumsInstrument onAddNote={onAddNote} />}
      </div>
    </div>
  );
}

export default EditorPanel;

